module.exports = ":host .bo__buttonbar {\n  margin-bottom: 1em; }\n\n:host .quota__booking-offices li {\n  margin-bottom: 0.5em; }\n\n:host .quota__booking-offices ul {\n  margin-bottom: 2em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-components/ticket-quota-collection/booking-offices/booking-offices.component.scss
// module id = uITI
// module chunks = 12